import { gql } from '@apollo/client'

export const GET_USER_ORDERS = gql`
  query getUserOrders {
    userOrders {
      id
      productTitle
      kind
      amountToPay
      createdAt
      isSubscription
      subscriptionStatus
      paymentStatus
      items {
        cartItemId
        name
        orderBump
        amountCents
        itemStatus
      }
    }
  }
`
